import type { NavItem } from '@/components/navigation/header-navigation';
import type { User } from '@/utils/session/fetch-user';

import { DesktopAvatarLabelGroup } from '@/components/avatar-card/desktop-avatar-label-group';
import { NavItemBase } from '@/components/navigation/base-components/nav-item';

export const NavDropdownMenu = ({
  items,
  user,
}: {
  items: (NavItem | { divider: true; label?: string })[];
  user?: User | null;
}) => {
  return (
    <div className="px-3 pb-2 md:max-w-84 md:p-0">
      <nav className="overflow-hidden rounded-2xl bg-primary py-2 shadow-xs ring-1 ring-secondary_alt md:p-2 md:shadow-lg">
        <ul className="flex flex-col gap-0.5">
          <DesktopAvatarLabelGroup size="md" className="w-full" user={user} />
          <li key={'avatar-divider'} className="py-0.5">
            <hr className="h-px w-full border-none bg-border-secondary" />
          </li>
          {items.map((item, index) => {
            if ('divider' in item) {
              // A divider has no label to key by, and dividers are fungible, so
              // a positional key is fine here. Keying on the (undefined) label
              // instead produces a null/duplicate key that remounts the list on
              // every render.
              return (
                // oxlint-disable-next-line react/no-array-index-key
                <li key={`divider-${index}`} className="py-0.5">
                  <hr className="h-px w-full border-none bg-border-secondary" />
                </li>
              );
            }
            return (
              <li key={item.label}>
                <NavItemBase
                  type="link"
                  href={item.href}
                  icon={item.icon}
                  current={item.current}
                  badge={item.badge}
                >
                  {item.label}
                </NavItemBase>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};
